import { orderStatus } from '@/constants';
import { sortTypeEnum } from '@/constants/global';
export default {
    filterOption: {
        // 주문 상태
        statusCode: orderStatus.ALL.code,
        // 기간
        // Example) betweenDate: [yyyy-mm-dd, yyyy-mm-dd],
        betweenDate: [],
        // 한 페이지당 보여질 항목 개수
        pageSize: 50,
        // 현재 페이지
        pageNumber: 1,
        // 검색 필드
        searchWord: {
            // 검색유형
            field: '',
            // 검색어
            value: '',
            // 검색조건
            condition: 'like',
        },
        // 발주유형
        hubType: '',
        // 결제방법
        payType: '',
        // 주문 종류 (퀵여부)
        orderType: '',
    },
    sortOption: [
        {
            // 정렬 대상
            field: 'orderedAt',
            // 정렬 기준
            value: sortTypeEnum.DESC,
        },
    ],
    // 카운트 UI 데이터
    count: {
        ALL: 0,
        DROP_FINISHED: 0,
        CANCELED: 0,
    },
    // 완료, 취소 데이터 (카운트에 사용)
    totalBackupData: {
        total: 0,
        totalCanceled: 0,
        totalDropFinished: 0,
    },
    // 배달 내역 리스트
    list: [],
    paginationData: {},
    cancledOrderList: [],
};
